import { useMemo } from 'react';

import { useSelector } from 'react-redux';
import sessionTokenRoles from 'selectors/sessionTokenRoles';
import { getQaPreviewSession, QaPreviewSession } from 'utils/qaPreviewSession';
import { hasAdminRole, hasSuperAdminRole } from 'utils/roleUtils';

/**
 * Returns the active QA preview session for the given report/project, but only for
 * admins/superadmins (the only roles that can reach Reports QA).
 */
const useQaPreviewSession = (
  reportId: string | undefined,
  projectId?: number | string,
): QaPreviewSession | null => {
  const userRoles = useSelector((state) => sessionTokenRoles(state));
  const isQaReviewer = hasAdminRole(userRoles) || hasSuperAdminRole(userRoles);

  return useMemo(
    () => (isQaReviewer ? getQaPreviewSession(reportId, projectId) : null),
    [isQaReviewer, reportId, projectId],
  );
};

export default useQaPreviewSession;
